const __WEBPACK_NAMESPACE_OBJECT__ = ElcRuntime.HypoContainer;